import { useContext } from 'react';
import { DEFAULT_LOCALE } from '../constants';
import { JucyUiProviderContext } from './JucyUiProvider';

export const useLocale = () => useContext(JucyUiProviderContext).locale || DEFAULT_LOCALE;
